import React from 'react';
import { colors } from '@ajaibid/components';

function Splash() {
  return (
    <div
      id="splash"
      style={{
        display: 'flex',
        backgroundColor: colors.AJAIB_BLUE_5,
        position: 'absolute',
        opacity: 1,
        zIndex: 10000,
        height: '100vh',
        overflow: 'auto',
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        style={{ verticalAlign: 'middle', transform: 'scale(0.5)' }}
        src="https://ajaib.co.id/wp-content/uploads/2020/03/new_splash.gif"
        alt="Loading"
      />
    </div>
  );
}

export default Splash;
